module.exports = __webpack_public_path__ + "img/CheckboxGroup.9c4a7a57.svg";